<template>
    <div class="row align-baseline justify-center">
        <v-stepper-header class="px-0">
            <template v-for="n in steps">
                <v-stepper-step
                        :key="`${n.number}-step`"
                        :complete="e1 > n.number"
                        editable
                        :step="n.number"
                >
                    <!-- {{ stepPrefix }} {{ n.number }}
                    <small class="v-label">{{ n.text }}</small> -->
                </v-stepper-step>

                <v-divider
                        v-if="n.number !== steps.length"
                        :key="`${n.number}-divider`"
                ></v-divider>
            </template>
        </v-stepper-header>
    </div>
</template>

<script>

    export default {
        data() {
            return {
            }
        },
        props: ['steps', 'e1', 'cartItems', 'stepPrefix'],
        mounted() {

        }
    }
</script>
<style>
    .theme--light.v-stepper .v-stepper__step__step .v-icon {
        line-height: 1.25rem;
        font-size: 0.75rem;
    }
    button.v-expansion-panel-header {
        border: none;
        background: transparent;
    }
    /* not in scope because added by javascript and has no data attribute then */
    .v-stepper__header .v-ripple__container {
        display:none;
    }
    .v-stepper__header .v-stepper__step--complete .v-icon__svg {
        padding: 4px;
    }
    .v-stepper__step {
      padding: 0 1.5rem;
    }
</style>
<style scoped>
    .v-label {
        font-weight: bold;
    }
    .v-stepper__header {
        height: auto;
        box-shadow: none;
    }
    .v-icon,
    .v-stepper__step__step,
    .v-stepper__step--inactive,
    .v-stepper__step--active {
        pointer-events: none;
    }

    .v-stepper__step {
      padding: 0 1.5rem;
    }
    .container .v-stepper .v-stepper__step--editable:hover,
    .container .v-stepper .v-stepper__step--editable:focus {
        background: none;
    }
</style>
